import { Component, OnInit } from '@angular/core';
import { EditorService } from "../../../editor.service";
@Component({
  selector: 'app-multipleselect',
  templateUrl: './multipleselect.component.html',
  styleUrls: ['./multipleselect.component.css']
})
export class MultipleselectComponent implements OnInit {
  multipleSelectData;
  constructor(private editorService: EditorService) { }

  ngOnInit() {
    let cardData = this.editorService.textInlineData;
    if (cardData && cardData.type == "MultiSelect") {
      this.multipleSelectData = cardData;
      this.initializeData(cardData)
    }
  }

  initializeData(cardData) {
    this.multipleChoiceOptions = cardData.allOptions;
  }
  multipleChoiceOptions = [{
    name: 'Option 1',
    type: 'Text',
    isValid: true,
    isHovered: false,
    dir: 'ltr'
  }, {
    name: 'Option 2',
    type: 'Text',
    isValid: false,
    isHovered: false,
    dir: 'ltr'
  }];
  //For Selecting the Correct Answer
  selectCorrectOption(ind) {
    if (this.multipleChoiceOptions[ind] && this.multipleChoiceOptions[ind].isValid != undefined) {
      this.multipleChoiceOptions[ind].isValid = !this.multipleChoiceOptions[ind].isValid;
    }
    let com = this.editorService.getIframeReference();
    com.configureMultiSelectCorrectAnswer(ind);
  }
  AddMoreOption() {
    let isValid = this.multipleChoiceOptions.length > 0 ? false : true;
    var obj = {
      name: 'Option  ' + (this.multipleChoiceOptions.length + 1) + '',
      type: 'Text',
      isValid: isValid,
      isHovered: false,
      hideEdit: false,
      dir: 'ltr',
      imageAlign: {
        type: 'left'
      }
    };
    this.multipleChoiceOptions.push(obj);
    let com = this.editorService.getIframeReference();
    com.addMultipleChoicesOptions();
  }
  //For Changing the option Content
  changeOptionText(ind) {
    if (this.multipleChoiceOptions && this.multipleChoiceOptions[ind]) {
      let com = this.editorService.getIframeReference();
      let optObj: any = {};
      optObj.content = this.multipleChoiceOptions[ind].name;
      optObj.dir = this.multipleChoiceOptions[ind].dir;
      com.onEditingMultiselectOptions(optObj, ind);
    }
  }
  //For Deleting the Option
  deleteMultiSelectOption(evt, ind) {
    if (this.multipleChoiceOptions[ind]) {
      this.multipleChoiceOptions.splice(ind, 1);
      let com = this.editorService.getIframeReference();
      com.removeMultiSelectOption(ind);
    }

  }



}



// WEBPACK FOOTER //
// ./src/app/bookShared/bookeditoption/bookEditOptionPopups/question/multipleselect/multipleselect.component.ts